import React, { FC } from 'react';
import cx from 'clsx';

import styles from './styles.module.scss';

const Shimmer: FC = () => (
  <div className={styles.businessInfo}>
    <div className={styles.merchantInfo}>
      <img src="data:," alt="" className={cx('shimmer', styles.logo)} />
      <div className={styles.info}>
        <h1 aria-hidden={true} className="shimmer" />
        <p className="shimmer" />
        <p className="shimmer" />
      </div>
    </div>
    <p className={cx('shimmer', styles.hours)} />
  </div>
);

export { Shimmer };
